define([
	'internal_util/Util',
	'internal_util/UiUtil',
	'view/UIView',
	'amdi18n-loader?!identity/nls/IdentityDecryptView_strings',
	'lib/jquery'
], function (
	Util,
	UiUtil,
	UIView,
	Strings,
	jQuery
) {
	'use strict';

	/**
	 * IdentityDecryptView class
	 */
	function IdentityDecryptView(decryptCallbacks) {
		var _view;

		_view = (function () {
			var $identityDecryptView = jQuery(
					"<div id='skIdS_identity-decrypt-container'>" +
						"<div>" +
							"<p>" + Strings.enter_pin + ":</p>" +
							"<div>" +
								"<input id='skIdS_identity-decrypt-password-input' type='password' maxlength='100' tabindex='1' autofocus='autofocus'>" +
								"<button id='skIdS_identity-decrypt-button' class='btn btn-default' tabindex='2' disabled='disabled'>" + Strings.confirm + "</button>" +
							"</div>" +
						"</div>" +
						"<span id='skIdS_identity-decrypt-input-error'></span>" +
					"</div>");

			$identityDecryptView.find('#skIdS_identity-decrypt-password-input')
				.on('input', function () {
					var secret = jQuery(this).val();

					$identityDecryptView.find('#skIdS_identity-decrypt-input-error').hide();

					if (secret.length === 0) {
						$identityDecryptView.find('#skIdS_identity-decrypt-button').prop('disabled', true);
					} else {
						$identityDecryptView.find('#skIdS_identity-decrypt-button').prop('disabled', false);
					}
				})
				.on('keypress', function (event) {
					var code = event.keyCode || event.which,
						secret = jQuery(this).val();

					if (code == 13 && secret.length > 0) { // RETURN key
						Util.callCallbacks(decryptCallbacks, secret);
					}
				});

			$identityDecryptView.find('#skIdS_identity-decrypt-button')
				.on('click', function () {
					var secret = $identityDecryptView.find('#skIdS_identity-decrypt-password-input').val();

					if (secret.length > 0) {
						Util.callCallbacks(decryptCallbacks, secret);
					}
				});

			$identityDecryptView.find('#skIdS_identity-decrypt-input-error').hide();

			return $identityDecryptView;
		})();

		UIView.call(this);


		// public methods

		this.get = function () {
			return _view;
		};

		this.update = function () {
			_view.find('#skIdS_identity-decrypt-password-input').val('');
			_view.find('#skIdS_identity-decrypt-button').prop('disabled', true);
			_view.find('#skIdS_identity-decrypt-input-error').empty().hide();
		};

		this.showError = function (error) {
			var $inputError = _view.find('#skIdS_identity-decrypt-input-error');

			$inputError.empty()
				.append(error)
				.show();
		};
	}

	IdentityDecryptView.prototype = Object.create(UIView.prototype);

	return IdentityDecryptView;
});


//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/view/identity/IdentityDecryptView.js
// module id = 98
// module chunks = 1